import * as React from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { media } from 'src/utils.js'
import { Logo, Nav } from './TopNavigationStyle'
import CustomModal from '../containers/CustomModal'
import PhoneNumber from '../atoms/PhoneNumber'
import { RedBtn } from '../atoms/input/buttons'

const googleTrust = require('src/assets/configurator/google_reviews.png')
const trustedShop = require('src/assets/redesign/trusted_shops_logo.png')
// const LogoImg = require('../../assets/benu_logo.png')

export const TopNavigation = () => {
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)

  const openModal = (e) => {
    if (
      location.href.includes('planung') &&
      !location.href.includes('detail')
    ) {
      e.preventDefault()
      setModalOpen(true)
    }
  }
  const onCloseModal = () => {
    setModalOpen(false)
  }

  return (
    <>
      <DontLeave open={modalOpen} onClose={onCloseModal} />
      <Nav>
        <Logo>
          <Link to='/' target='_self' onClick={openModal}>
            <img src={DynamicLogo()} />
          </Link>
        </Logo>
        <SaveStatus id='saveArea'>
          <SaveStatusItem id='saveAreaSaving'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'>
              <line x1='12' y1='2' x2='12' y2='6'></line>
              <line x1='12' y1='18' x2='12' y2='22'></line>
              <line x1='4.93' y1='4.93' x2='7.76' y2='7.76'></line>
              <line x1='16.24' y1='16.24' x2='19.07' y2='19.07'></line>
              <line x1='2' y1='12' x2='6' y2='12'></line>
              <line x1='18' y1='12' x2='22' y2='12'></line>
              <line x1='4.93' y1='19.07' x2='7.76' y2='16.24'></line>
              <line x1='16.24' y1='7.76' x2='19.07' y2='4.93'></line>
            </svg>
            <p>SPEICHERN</p>
          </SaveStatusItem>
          <SaveStatusItem id='saveAreaDone'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'>
              <polyline points='20 6 9 17 4 12'></polyline>
            </svg>
            <p>GESPEICHERT</p>
          </SaveStatusItem>
          <SaveStatusItem id='saveAreaError'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'>
              <path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'></path>
              <line x1='12' y1='9' x2='12' y2='13'></line>
              <line x1='12' y1='17' x2='12.01' y2='17'></line>
            </svg>
            <p>FEHLER!</p>
          </SaveStatusItem>
        </SaveStatus>
        <PhoneNumber />
      </Nav>
    </>
  )
}

const DynamicLogo = () => {
  if (process.env.REACT_APP_DOMAIN === 'bestattungsinfo') {
    return 'https://res.cloudinary.com/dkyl4jbxx/image/upload/v1688648512/assets/configurator/logos/logo-bestattungsinfo.png'
  } else if (process.env.REACT_APP_DOMAIN === 'die-baumbestattung') {
    return 'https://res.cloudinary.com/dkyl4jbxx/image/upload/v1688648512/assets/configurator/logos/logo-die-baumbestattung.png'
  } else if (process.env.REACT_APP_DOMAIN === 'clever') {
    return 'https://res.cloudinary.com/dkyl4jbxx/image/upload/v1688648512/assets/configurator/logos/logo-clever.png'
  } else {
    return 'https://res.cloudinary.com/dkyl4jbxx/image/upload/v1688648512/assets/configurator/logos/logo-benu.png'
  }
}
interface DontLeaveProps {
  open: boolean
  onClose: () => void
}

export const DontLeave = (props: DontLeaveProps) => {
  const { open, onClose } = props
  return (
    <CustomModal
      onClose={onClose}
      open={open}
      title='Fast geschafft'
      cancelX
      hideCloseButton>
      <p>
        Transparenz ist im Bestattungsbereich nicht selbstverständlich. Sie sind
        nur noch wenige Schritte von einem kompletten Angebot mit sämtlichen
        Kosten und Gebühren entfernt.
      </p>
      <RedBtn onClick={onClose} center>
        Planung fortsetzen
      </RedBtn>
      <ImageAlign>
        <img src={googleTrust} width='80' alt='Google' />
        <img src={trustedShop} width='35' alt='SSL Secure Connection' />
      </ImageAlign>
      <p style={{ color: 'red', margin: 15 }}>
        Wenn sie jetzt Ihre Anfrage stornieren, gehen alle bereits eingegebenen
        Antworten verloren.
      </p>
      <CustomLink to='/' target='_self'>
        <u>Anfrage stornieren</u>
      </CustomLink>
    </CustomModal>
  )
}

const SaveStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  p {
    padding: 0px;
  }
`
const SaveStatusItem = styled.div`
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 4px;

  svg {
    height: 16px;
    width: 16px;
    stroke: #46595b;
    margin-right: 4px;
  }
  p {
    padding: 0px;
    margin: 0px;
    color: #46595b;
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }
`

const ImageAlign = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    margin: 7.5px;
  }
  ${media.largePhone`
    flex-direction: column;
  `}
`

const CustomLink = styled(Link)`
  font-size: 15px;
  color: #4a4a4a;
`

export default withRouter(TopNavigation)



// WEBPACK FOOTER //
// ./src/components/layout/TopNavigation.tsx